<template>
  <v-container grid-list-md fluid>
    <new-procedure v-model="dialog" @saved="getProcedures" />
    <new-prescription v-model="prescDialog" :patient-id="prescPatientId" @saved="getProcedures" />
    <v-layout row wrap>
      <!-- history -->
      <v-flex xs12>
         <div class="section-title di-flex align-center justify-space-between">
          <span>History</span>
          <div style="width: 50%;">
            <v-text-field
              v-debounce:500ms="getProcedures"
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              class="rounded"
              label="Search"
              hide-details
              single-line
              outline
            >
              <v-tooltip top slot="append-outer">
                <v-icon
                  class="mx-2"
                  medium
                  slot="activator"
                  @click="dialog = true" 
                  color="secondary"
                >mdi-plus-circle</v-icon>

                <span>New Procedure</span>
              </v-tooltip>
            </v-text-field>
          </div>
        </div>

        <v-data-table
          :headers="headers"
          disable-initial-sort
          :items="history.data"
          :pagination.sync="pagination"
          :rows-per-page-items="per_page"
          :total-items="history.meta.total"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{ props.item.patient_name }}</td>
              <td>{{ props.item.procedure_name }}</td>
              <td>{{ props.item.date | moment('YYYY-MM-DD') }}</td>
              <td>{{ props.item.fee | currency('AFN') }}</td>
              <td class="text-capitalize" :class="props.item.status">{{ props.item.status }}</td>
              <td>
                <v-tooltip top v-if="props.item.status === 'paid'">
                  <v-icon slot="activator" color="primary" @click="done(props.item)">mdi-check</v-icon>
                  <span>Done</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-icon slot="activator" @click="addPresc(props.item)">mdi-plus</v-icon>
                  <span>Add Prescription</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import NewProcedure from "./new";
import NewPrescription from "./newPres";
export default {
  middleware: "procedure",
  // layout: "single",

  components: {
    NewProcedure,
    NewPrescription
  },

  data() {
    return {
      dialog: false,
      prescDialog: false,
      prescPatientId: "",
      search:"",
      history: {
        data: [],
        meta: {},
        links: {}
      },
      pagination: {descending: true},
      headers: [
        { text: "Patient ", value: "patients.name" },
        { text: "Name", value: "procedures.name" },
        { text: "Date", value: "date" },
        { text: "Fee", value: "fee" },
        { text: "Status", value: "status" },
        { text: "", value: "status" }
      ]
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getProcedures();
      }
    }
  },
  methods: {
    addPresc({ patient_id }) {
      this.prescPatientId = patient_id;
      this.prescDialog = true;
    },
    getProcedures() {
      // history
      const { sortBy, descending, page, rowsPerPage } = this.pagination;

      let query = `/api/procedure_room?rows_per_page=${rowsPerPage}&search=${encodeURIComponent(
        this.search
      )}&page=${page}`;

      if (sortBy) query = `${query}&sort_by=${sortBy}`;
      if (descending !== null) query = `${query}&desc=${descending ? 1 : 0}`;
      
      this.axios
        .get(query)
        .then(resp => {
          this.history = resp.data;
        });
    },

    done(procedure) {
      this.$modal.show({
        mode: "confirm",
        message: `Make done the procedure: ${procedure.procedure_name}?`,
        onConfirm: async () => {
          await this.axios.put(`/api/procedure_room/${procedure.id}/done`);
          this.getProcedures();
        }
      });
    },

    deleteProcedure(procedure) {
      this.$modal.show({
        message: `Are you sure, you want to delete this procedures?`,
        mode: "delete",
        onConfirm: async () => {
          await this.axios.delete(`/api/procedures/${procedure.id}`);
          this.getProcedures();
        }
      });
    }
  },
  mounted() {
    this.getProcedures();
  }
};
</script>

<style>
.hover {
  cursor: pointer;
}
</style>